import React from 'react'
import { Updater, async, AsyncState, fromJSX, Widget } from 'widgets-for-react'
import { SubscriptionData } from '../../sharepointPageApi/types/pageData'
import { InviewProps } from '../blocksState'
import { AllSubscriptionsBlockLayout } from './allSubscriptionsBlockLayout'

export type AllSubscriptionsBlock = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  subscriptionsState: AsyncState<SubscriptionData[]>
}

export const allSubscriptionsBlockWidget = (
  block: AllSubscriptionsBlock
): Widget<Updater<AsyncState<SubscriptionData[]>>> =>
  async<SubscriptionData[]>(block.subscriptionsState, items =>
    fromJSX(() => <AllSubscriptionsBlockLayout {...block} children={items} />)
  )
